import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ElementRef,
  ViewChild,
  AfterViewInit,
  DoCheck,
} from '@angular/core';
import { Subscription, fromEvent } from 'rxjs';
import { LanguageService } from '../../../service/language.service';

@Component({
  selector: 'app-appli-main',
  templateUrl: './appli-main.component.html',
  styleUrls: ['./appli-main.component.scss'],
})
export class AppliMainComponent implements AfterViewInit, OnInit, DoCheck {
  @Input() appList: AppliMain[];
  @Input() focusIndex: Number;
  @Output() changeFocus = new EventEmitter<number>();
  @Output() launchAppli = new EventEmitter<number>();
  @Output() resetAllFocus = new EventEmitter<void>();
  constructor(private languageService: LanguageService) {}

  sub: Subscription;
  FirstTime = false;
  FullScreen = false;
  lang = this.languageService.language;

  @ViewChild('movie') movie: ElementRef;

  ngAfterViewInit() {
    this.movie.nativeElement.volume = 0.5;
  }

  ngDoCheck() {
    if (this.movie) {
      this.movie.nativeElement.volume = 0.5;
    }
  }

  ngOnInit() {
    const keyDown$ = fromEvent<KeyboardEvent>(document, 'keydown');
    this.sub = keyDown$.subscribe(d => {
      if (d.key === 'Enter' && this.FullScreen == true) {
        // 決定キーが押されてフルスクリーンの場合は解除
        console.log('Change to window Mode mode');
        this.FullScreen = false;
      } else if (d.key === 'Enter' && this.FirstTime === false) {
        // 決定キーがおされて初回でない場合はフルスクリーン
        console.log('Change to window mode');
        this.FullScreen = true;
      } else if (this.FirstTime === true) {
        // 初回だった場合は無視
        console.log('First Time');
        this.FirstTime = false;
      } else {
        // それ以外は初回にする
        console.log('soreigai');
        this.FirstTime = true;
      }
      this.movie.nativeElement.volume = 0.1;
    });
  }

  toggleFullscreen() {
    //var elem = document.getElementById("myvideo");
    //console.log(elem);
    //elem.requestFullscreen();
    if (this.FullScreen) {
      this.FullScreen = false;
    } else {
      this.FullScreen = true;
    }
  }
  click(i: number) {
    this.launchAppli.emit(i);
  }
  blur() {
    this.resetAllFocus.emit();
  }
}
